// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell() {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontSize: "12px",
          fontWeight: 500,
          padding: "24px 16px",
          "&:not(:last-of-type)": {
            "&:after": {
              display: "none !important",
            },
          },
        },
        body: {
          fontSize: "14px",
          fontWeight: 400,
          padding: "16px",
        },
      },
    },
  };
}
